export function isMember<T>(user: unknown): user is T {
    if (!user || typeof user !== 'object') {
        return false;
    }
    return '__typename' in user && user['__typename'] === 'Me';
}
